import { gql } from '@apollo/client';

// DSP包裹详情查询：根据追踪号获取DSP包裹详情
export const GET_DSP_PACKAGE_DETAIL_BY_TRACKING_NUMBER = gql`
  query GetDspPackageDetailByTrackingNumber($trackingNumber: String!) {
    getDspPackageDetailByTrackingNumber(trackingNumber: $trackingNumber) {
      orderId
      trackingNumber
      orderStatus
      deliveredAt
      preDeliveredAt
      deliverAt
      assignedDriver
      taskDate
      deliveryAttempts
      deliveryTaskOrder {
        id
        stopNumber
        subStopNumber
        routeName
        orderNote {
          id
          note
          lang
          orderNoteTranslations {
            lang
            translateNote
          }
        }
      }
      recipientName
      recipientPhone
      recipientAddress
      exceptionReasonCode
      exceptionSubReasons
      exceptionImageS3UrlsJson
      podImageS3KeysJson
      podImageS3UrlsJson
      deliveredBy
      markedBy
      failAt
      isDelivered
      channelName
      driverDeliveryNote {
        note
        lang
        orderNoteTranslations {
          lang
          translateNote
        }
      }
      packageEvents {
        eventId
        time
        type
        title
        details
        imageS3UrlsJson
        nextAction
        exceptionReasonCode
        exceptionSubReasons
        channelId
        channelApiVersion
        phoneNumber
        failReason
        weightKg
        sortingMachineCode
        sortingMachineType
        bagNumber
        bagSortingCode
        scanSource
        deliveryMethod
        latitude
        longitude
        deliveryDistance
        reason
        oldRecipientAddress {
          id
          fullName
          addressLine1
          addressLine2
          city
          state
          zipcode
          phoneNumber
          email
          countryCode
          extension
          company
          instructions
        }
        newRecipientAddress {
          id
          fullName
          addressLine1
          addressLine2
          city
          state
          zipcode
          phoneNumber
          email
          countryCode
          extension
          company
          instructions
        }
        podComment
        previousStatus
        previousReviewNotes
        newStatus
        driverAccountId
        driverName
        driverPhone
        dspId
        dspName
        operatorName
        operatorPhone
        operatorRole
        messageKey
        oldOrderNote{
          note
          lang
          orderNoteTranslations {
            translateNote
            lang
          }
        }
        newOrderNote{
          note
          lang
          orderNoteTranslations {
            translateNote
            lang
          }
        }
        driverDeliveryNote{
          note
          lang
          orderNoteTranslations {
            translateNote
            lang
          }
        }
      }
    }
  }
`;

export const GET_DSP_PACKAGE_DETAIL = gql`
  query GetDspPackageDetailByTrackingNumber($trackingNumber: String!) {
    getDspPackageDetailByTrackingNumber(trackingNumber: $trackingNumber) {
      orderId
      trackingNumber
      orderStatus
      deliveredAt
      preDeliveredAt
      deliverAt
      assignedDriver
      taskDate
      deliveryAttempts
      deliveryTaskOrder {
        id
        stopNumber
        subStopNumber
        routeName
        orderNote {
          id
          note
          lang
          orderNoteTranslations {
            lang
            translateNote
          }
        }
      }
      recipientName
      recipientPhone
      recipientAddress
      exceptionReasonCode
      exceptionSubReasons
      exceptionImageS3KeysJson
      exceptionImageS3UrlsJson
      podImageS3KeysJson
      podImageS3UrlsJson
      deliveredBy
      markedBy
      failAt
      isDelivered
      podReviewStatus
      podUpdateTimeString
      isAllowUpdatePod
      isPopUp
      deliveryMethod
      deliveryRevokeStatus {
        canRevoke
        revokeDeadline
        hintMessage {
          zh
          en
          es
          appendDeadline
        }
      }
      driverDeliveryNote {
        note
        lang
        orderNoteTranslations {
          lang
          translateNote
        }
      }
    }
  }
`;

export const GET_DSP_SCAN_DETAIL = gql`
  query GetDspPackageDetailByTrackingNumber($trackingNumber: String!) {
    getDspPackageDetailByTrackingNumber(trackingNumber: $trackingNumber) {
      trackingNumber
      deliverAt
      assignedDriver
      deliveryAttempts
      deliveryTaskOrder {
        id
        stopNumber
        subStopNumber
        routeName
        orderNote {
          id
          note
          lang
          orderNoteTranslations {
            lang
            translateNote
          }
        }
      }
      recipientName
      recipientPhone
      recipientAddress
      recipientLatitude
      recipientLongitude
    }
  }
`;

export const GET_DSP_PARTICULARS_DETAIL = gql`
  query GetDspPackageDetailByTrackingNumber($trackingNumber: String!) {
    getDspPackageDetailByTrackingNumber(trackingNumber: $trackingNumber) {
      trackingNumber
      deliverAt
      assignedDriver
      taskDate
      deliveryAttempts
      deliveryTaskOrder {
        id
        stopNumber
        subStopNumber
        routeName
        orderNote {
          id
          note
          lang
          orderNoteTranslations {
            lang
            translateNote
          }
        }
      }
      recipientName
      recipientPhone
      recipientAddress
    }
  }
`;

export interface OrderNoteTranslation {
  lang: string;
  translateNote: string;
}

export interface OrderNote {
  id: number;
  note: string;
  lang: string;
  orderNoteTranslations: OrderNoteTranslation[];
}

export interface DeliveryTaskOrder {
  id: number;
  stopNumber: number;
  subStopNumber: string;
  routeName?: string;
  isDelivered: boolean;
  isPickedUp: boolean;
  isDspArrivalScanCompleted: boolean;
  orderNote?: OrderNote;
}

export interface OrderAddress {
  id?: string;
  fullName?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  phoneNumber?: string;
  email?: string;
  countryCode?: string;
  extension?: string;
  company?: string;
  instructions?: string;
}

export interface PackageEvent {
  eventId: string;
  time: string; // 后端返回的是字符串格式的时间戳
  type: string;
  title: string;
  details: string[];
  imageS3UrlsJson?: string[];
  nextAction?: string;
  exceptionReasonCode?: string;
  exceptionSubReasons?: string[] | null;
  channelId?: number;
  channelApiVersion?: number;
  phoneNumber: string;
  failReason: string;
  deliveryMethod: string;
  oldRecipientAddress?: OrderAddress;
  newRecipientAddress?: OrderAddress;
  podComment?: string[],
  previousStatus?: string,
  newStatus?: string,
  previousReviewNotes?: string[],
  weightKg?: number,
  oldOrderNote?: OrderNote,
  newOrderNote?: OrderNote,
  driverAccountId?: string;
  driverName?: string;
  driverPhone?: string;
  dspId?: string;
  dspName?: string;
  operatorName?: string;
  operatorPhone?: string;
  operatorRole?: string;
  operatePlatformType?: string;  // 操作平台类型（用于MarkAsException事件）
  messageKey?: string;  // LogScan事件的消息键
  latitude?: number;
  longitude?: number;
  deliveryDistance?: number;
  sortingMachineCode?: string;  // 分拣机编码
  sortingMachineType?: string;  // 分拣机类型
  bagNumber?: string;  // 包牌号（装包扫描事件）
  bagSortingCode?: string;  // 包牌分拣码（装包扫描事件）
  scanSource?: string;  // 装包扫描来源：CLIENT_CARTON_SCAN/MANUAL/CROSS_BELT
  driverDeliveryNote?: OrderNote;  // 司机投递备注
  reason?: string;              // 事件原因（如地址改写时的"运营规则改派"）
}

export interface DspPackageDetail {
  orderId: string;
  trackingNumber: string;
  orderStatus?: string;
  deliveredAt: number;
  preDeliveredAt?: number | null;
  deliverAt: number;
  assignedDriver: string;
  taskDate?: string;
  deliveryAttempts: number;
  deliveryTaskOrder?: DeliveryTaskOrder;
  recipientName?: string;
  recipientPhone?: string;
  recipientAddress?: string;
  recipientLatitude?: number;
  recipientLongitude?: number;
  exceptionReasonCode: string;
  exceptionSubReasons?: string[] | null;
  exceptionImageS3KeysJson: string[];
  exceptionImageS3UrlsJson: string[];
  podImageS3KeysJson: string[];
  podImageS3UrlsJson: string[];
  packageEvents: PackageEvent[];
  deliveredBy?: string;  // 签收操作人员姓名
  markedBy?: string;     // 标记失败操作人员姓名
  failAt?: number;       // 标记失败时间（时间戳）
  isDelivered?: boolean; // 是否已签收
  channelName: string; // 客户名称
  podReviewStatus?: number; // POD审核状态
  podUpdateTimeString?: string | null;
  isAllowUpdatePod?: boolean;
  isPopUp?: boolean;
  deliveryMethod: string;
  deliveryRevokeStatus?: {
    canRevoke: boolean;
    revokeDeadline: number | null; // Unix 秒级时间戳，null 表示无预妥投记录
    hintMessage?: {
      zh: string;
      en: string;
      es: string;
      appendDeadline: boolean;
    } | null;
  };
  driverDeliveryNote?: OrderNote;  // 司机投递备注
}

export interface GetDspPackageDetailByTrackingNumberResponse {
  getDspPackageDetailByTrackingNumber: DspPackageDetail;
}

export interface GetDspPackageDetailByTrackingNumberVariables {
  trackingNumber: string;
}

// 根据S3 Key获取图片URL
export const GET_IMAGE_URL_BY_S3_KEY = gql`
  query GetImageUrlByS3Key($s3Key: String!) {
    getImageUrlByS3Key(s3Key: $s3Key)
  }
`;

// 根据S3 Key列表批量获取图片URL
export const GET_IMAGE_URLS_BY_S3_KEYS = gql`
  query GetImageUrlsByS3Keys($s3Keys: [String!]!) {
    getImageUrlsByS3Keys(s3Keys: $s3Keys)
  }
`;

export interface GetImageUrlByS3KeyResponse {
  getImageUrlByS3Key: string | null;
}

export interface GetImageUrlByS3KeyVariables {
  s3Key: string;
}

export interface GetImageUrlsByS3KeysResponse {
  getImageUrlsByS3Keys: string[];
}

export interface GetImageUrlsByS3KeysVariables {
  s3Keys: string[];
}
